import { render } from "./newIndexTwo.vue?vue&type=template&id=0831221d&scoped=true"
import script from "./newIndexTwo.vue?vue&type=script&lang=js"
export * from "./newIndexTwo.vue?vue&type=script&lang=js"

import "./newIndexTwo.vue?vue&type=style&index=0&id=0831221d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0831221d"]])

export default __exports__